
export default {
	emits: ['onClick'],
	props: {
		text: {
			required: true,
			type: String,
		},
		classNm: {
			required: false,
			type: String,
		},
	},
};
